import { globalTypes } from '../types';
import { reduceAction } from '../helpers';

import types from './types';

export const initialState = () => ({});
const reducers = (state = initialState(), action) => {
    switch (action.type) {
        case globalTypes.INITIALIZE:
            return initialState();

        case types.SET_LOADING:
            return reduceAction(state, 'loading', !!action.payload);

        case types.SET_NOTIFY_ME_LIST:
            return {
                ...state,
                data: { ...action.payload },
            };

        case types.REMOVE_FROM_NOTIFY_ME_LIST:
            return {
                ...state,
                data: {
                    ...state.data,
                    results: state.data.results.filter(
                        item => item.product.code !== action.payload.code,
                    ),
                },
            };

        default:
            return state;
    }
};

export default reducers;
